import axios from "axios";
import config from '@/helpers/config'; 

export default $axios => {   
    return {
        $axios,
        
        async login(form) {  
            return await $axios.post('/signin', form); 
        },

        async register(form) {  
            return await $axios.post('/signup', form); 
        },
        
        async check(form) {  
            return await $axios.post('/check', form); 
        }, 

        async verifyCode(form) { 
            return await axios.post(`${config.apiUrl}/phone/verification/verify`, form, {
                headers: {
                    'Authorization': `Bearer ${config.smsToken}`
                }
            });
        },

        async signup() {},

        async send(form) { 
            return await axios.post(`${config.apiUrl}/phone/verification/send-code`, form, {
                headers: {
                    'Authorization': `Bearer ${config.smsToken}`
                }
            });
        }
    }; 
}; 
 